export const ThemeMode = {
	LIGHT: "light",
	DARK: "dark",
	SYSTEM: "system",
} as const;

export type ThemeMode = (typeof ThemeMode)[keyof typeof ThemeMode];

export const ColorScheme = {
	LIGHT: "light",
	DARK: "dark",
} as const;

export type ColorScheme = (typeof ColorScheme)[keyof typeof ColorScheme];

export const BRAND = {
	accent: "oklch(0.2253 0.0738 254.85)",
	accentForeground: "oklch(1 0 0)",
} as const;
